/** @format */

import {
    RecoveryState,
    RecoveryTransitionSource,
} from "../../utility/types/collectTypes";

// Display labels — keep in sync with server/src/collect/types/recoveryEnums.ts
export const RECOVERY_STATE_LABELS: Record<RecoveryState, string> = {
    monitoring: "Monitoring",
    due_soon: "Due soon",
    due_today: "Due today",
    overdue: "Overdue",
    active_recovery: "Active recovery",
    promise_to_pay: "Promise to pay",
    partially_paid: "Partially paid",
    disputed: "Disputed",
    manual_review: "Manual review",
    legal_action: "Legal action",
    recovered: "Recovered",
    closed: "Closed",
};

// Color tokens used by the chip background/border. Mirrors the visual
// vocabulary used elsewhere in the Collect UI (green=good, amber=watch,
// red=needs attention, slate=neutral).
type RecoveryTone = "neutral" | "good" | "info" | "warn" | "bad";

const STATE_TONE: Record<RecoveryState, RecoveryTone> = {
    monitoring: "neutral",
    due_soon: "info",
    due_today: "info",
    overdue: "warn",
    active_recovery: "warn",
    promise_to_pay: "info",
    partially_paid: "info",
    disputed: "bad",
    manual_review: "bad",
    legal_action: "bad",
    recovered: "good",
    closed: "neutral",
};

const TONE_COLORS: Record<
    RecoveryTone,
    { bg: string; fg: string; border: string }
> = {
    neutral: { bg: "#f1f5f9", fg: "#475569", border: "rgba(71,85,105,0.25)" },
    good: { bg: "#ecfdf5", fg: "#0f7a5b", border: "rgba(15,122,91,0.25)" },
    info: { bg: "#eff6ff", fg: "#1d4ed8", border: "rgba(29,78,216,0.25)" },
    warn: { bg: "#fff7ed", fg: "#b45309", border: "rgba(180,83,9,0.25)" },
    bad: { bg: "#fef2f2", fg: "#b91c1c", border: "rgba(185,28,28,0.25)" },
};

export function recoveryStateLabel(state?: RecoveryState | null): string {
    if (!state) return "—";
    return RECOVERY_STATE_LABELS[state] || state;
}

export function recoveryStateColors(
    state?: RecoveryState | null,
): { bg: string; fg: string; border: string } {
    if (!state) return TONE_COLORS.neutral;
    return TONE_COLORS[STATE_TONE[state]] || TONE_COLORS.neutral;
}

const SOURCE_LABELS: Record<RecoveryTransitionSource, string> = {
    user_manual: "Manual",
    system_reconciler: "Auto (reconciler)",
    system_sync: "Sync",
    webhook: "Webhook",
    promise_service: "Promise",
    escalation_engine: "Escalation",
    reply_classifier: "Reply classifier",
};

export function transitionSourceLabel(
    source?: RecoveryTransitionSource,
): string {
    if (!source) return "—";
    return SOURCE_LABELS[source] || source;
}
